var _path, _path2, _rect, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTitle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.82 12.573H19.135c-1.354 0-2.451 1.073-2.451 2.398v39.968c0 1.325 1.097 2.398 2.45 2.398H51.82c1.354 0 2.451-1.074 2.451-2.398V14.971c0-1.325-1.097-2.398-2.45-2.398zM19.135 8.576c-3.61 0-6.537 2.863-6.537 6.395v39.968c0 3.532 2.927 6.395 6.537 6.395h32.683c3.61 0 6.537-2.863 6.537-6.395V14.971c0-3.532-2.927-6.395-6.537-6.395H19.136z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.82 13.159H19.135c-1.023 0-1.852.811-1.852 1.812v39.968c0 1 .829 1.812 1.852 1.812h32.683c1.023 0 1.852-.811 1.852-1.812V14.971c0-1-.829-1.812-1.852-1.812zm-32.684-1.172h32.683c1.685 0 3.05 1.336 3.05 2.984v39.968c0 1.648-1.365 2.984-3.05 2.984H19.136c-1.685 0-3.05-1.336-3.05-2.984V14.971c0-1.648 1.365-2.984 3.05-2.984zm0-2.825c-3.28 0-5.938 2.6-5.938 5.809v39.968c0 3.208 2.659 5.809 5.938 5.809h32.683c3.28 0 5.938-2.6 5.938-5.809V14.971c0-3.208-2.659-5.809-5.938-5.809H19.136zM12 14.971c0-3.856 3.195-6.981 7.136-6.981h32.683c3.941 0 7.136 3.125 7.136 6.98V54.94c0 3.856-3.195 6.981-7.136 6.981H19.136C15.195 61.92 12 58.795 12 54.94V14.971z",
    fill: "current"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 47.938,
    width: 24,
    height: 2.996,
    rx: 1.498,
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.867 25.833A5.863 5.863 0 0136 31.693a5.863 5.863 0 01-5.867-5.86A5.863 5.863 0 0136 19.974a5.863 5.863 0 015.867 5.86zM25.733 38.84c0-3.697 3.387-6.47 7.017-5.745l.373.075c1.9.379 3.854.379 5.753 0l.373-.075c3.63-.725 7.017 2.048 7.017 5.745v1.642c0 .809-.656 1.465-1.466 1.465H27.2c-.81 0-1.467-.656-1.467-1.465v-1.642z",
    fill: "current"
  })));
}

export default SvgTitle;